import axios from "../_services/api/axios";

export const useSupportToken = () => {
  return async (supportToken) => {
    try {
      const response = await axios.post("/auth/support/token", {
        token: supportToken,
      });

      let {
        user_name: email,
        token,
        user_id,
        first_name,
        last_name,
        account_name,
        parent_user_id,
        impersonation_for_id,
      } = response.data;

      if (impersonation_for_id && token) {
        const impersonatedUser = await axios.get(
          `/users/${impersonation_for_id}`,
          { skipRedirectToLoginIfUnauthorized: true, token, impersonation_for_id }
        );

        user_id = impersonatedUser.data.id ? impersonatedUser.data.id : "";

        email = impersonatedUser.data.email;
        first_name = impersonatedUser.data.first_name
          ? impersonatedUser.data.first_name
          : "";

        last_name = impersonatedUser.data.last_name
          ? impersonatedUser.data.last_name
          : "";

        account_name = impersonatedUser.data.account_name
        ? impersonatedUser.data.account_name
        : "";

        parent_user_id = impersonatedUser.data.parent_user_id
        ? impersonatedUser.data.parent_user_id
        : undefined
      }

      return {
        isValidToken: true,
        user: {
          email: email ? email : "",
          token: token ? token : "",
          user_id: user_id ? user_id : "",
          first_name: first_name ? first_name : "",
          last_name: last_name ? last_name : "",
          account_name: account_name ? account_name : "",
          parent_user_id: parent_user_id ? parent_user_id : undefined,
          impersonation_for_id: impersonation_for_id
            ? impersonation_for_id
            : undefined,
        },
      };
    } catch (e) {
      console.error(e);
    }

    return { isValidToken: false };
  };
};



// WEBPACK FOOTER //
// ./src/hooks/useSupportToken.js